import { render, staticRenderFns } from "./CorrelationGroupList.vue?vue&type=template&id=1df5b3e4&scoped=true"
import script from "./CorrelationGroupList.vue?vue&type=script&lang=ts"
export * from "./CorrelationGroupList.vue?vue&type=script&lang=ts"
import style0 from "./CorrelationGroupList.vue?vue&type=style&index=0&id=1df5b3e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df5b3e4",
  null
  
)

export default component.exports